import React, { useState } from "react";
import "./syllabus.css";
import "../../page_content.css";
import Accordion from "../../../components/reuseable_comp/accordion/Accordion";

const Syllabus = () => {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [activeSem, setActiveSem] = useState(null);

  const syllabusData = [
    // 1st accordion content
    {
      title: "B.Tech Marine Engineering",
      sectionTitle:
        "Course Structure Outline For 4 YEAR B.Tech Marine Engineering",
      semesters: [
        {
          title: "1st Year",
          // sectionTitle:
          //   "COURSE STRUCTURE OUTLINE FOR 4 YEAR B TECH (MARINE ENGINEERING)",
          tables: [
            [
              ["First Year (B Tech) SEMESTER I"],
              ["Sr No", "Course Code", "Course Name"],
              [1, "ME/22/T11", "Communicative English"],
              [2, "ME/22/T12", "Mathematics-l"],
              [3, "ME/22/T13", "Marine Induction & Aptitude"],
              [4, "ME/22/T14", "Basic Electrical & Electronics Engineering"],
              [5, "ME/22/T15", "Workshop Technology"],
              [6, "ME/22/T16", "Applied Thermodynamics - 1"],
              [7, "ME/22/T17", "Engineering Drawing"],
              ["Practical Subjects"],
              ["Sr No", "Course Code", "Course Name"],
              [8, "ME/22/P18", "Communicative English Laboratory"],
              [
                9,
                "ME/22/P19",
                "Basic Electrical & Electronics Engineering Laboratory",
              ],
              [10, "ME/22/P20", "Workshop Practical - I"],
              [11, "ME/22/N21", "Officer Like Qualities"],
            ],

            [
              ["First Year (B. Tech) SEMESTER II"],
              ["Sr. No.", "Course Code", "Course Name"],
              [1, "ME/22/T21", "Material Science"],
              [2, "ME/22/T22", "Mathematics - II"],
              [3, "ME/22/T23", "Engineering Mechanics"],
              [4, "ME/22/T24", "Electrical Machines - I"],
              [5, "ME/22/T25", "Fluid Mechanics"],
              [6, "ME/22/T26", "Applied Thermodynamics -II"],
              ["Practical Subjects"],
              ["Sr No", "Course Code", "Course Name"],
              [7, "ME/22/P27", "Engineering Mechanics Laboratory"],
              [8, "ME/22/P28", "Electrical Machine Laboratory"],
              [9, "ME/22/P29", "Thermodynamics Laboratory"],
              [10, "ME/22/P30", "Workshop Practical - II"],
              [11, "ME/22/P31", "Material Science Laboratory"],
              [12, , "Tutorial SHD/SCIL"],
              [13, "ME/22/N32", "Officer Like Qualities"],
            ],
          ],
        },
        {
          title: "2nd Year",
          // sectionTitle: "",
          tables: [
            [
              ["Second Year (B Tech) SEMESTER III"],
              ["Sr. No.", "Course Code", "Course Name"],
              [1, "ME/22/T31", "Environmental Studies"],
              [2, "ME/22/T32", "Theory of Machines"],
              [3, "ME/22/T33", "Strength of Materials - I"],
              [4, "ME/22/T34", "Electrical Machines - II"],
              [5, "ME/22/T35", "Marine Machines Drawing"],
              [6, "ME/22/T36", "Hydraulic Machines"],
              [7, "ME/22/T37", "Computer Science - I"],
              ["Practical Subjects"],
              ["Sr. No.", "Course Code", "Course Name"],
              [8, "ME/22/P38", "Computer Science Laboratory"],
              [9, "ME/22/P39", "Hydraulics Laboratory"],
              [10, "ME/22/P40", "Electrical Machines laboratory-II"],
              [11, "Tutorial SHD/SCIL"],
              [12, "ME/22/N41", "Officer Like Qualities"],
            ],
            [
              ["Second Year (B Tech) SEMESTER IV"],
              ["Sr. No.", "Course Code", "Course Name"],
              [1, "ME/22/T41", "Ship Construction"],
              [2, "ME/22/T42", "Marine Auxiliary Machine – I"],
              [3, "ME/22/T43", "Strength of Materials – II"],
              [4, "ME/22/T44", "Marine Internal Combustion Engine – I"],
              [5, "ME/22/T45", "Analog & Digital Electronics"],
              [6, "ME/22/T46", "Machine Design"],
              [7, "ME/22/T47", "Computer Science – II"],
              ["Practical Subjects"],
              [8, "ME/22/P48", "Mechanical Laboratory"],
              [9, "ME/22/P49", "Analog & Digital Electronics Laboratory"],
              [10, "VAC", "Welding Workshop (4G)"],
              [11, "ME/N50", "Officer Like Qualities"],
            ],
          ],
        },
        {
          title: "3nd Year",
          tables: [
            [
              ["Third Year (B Tech) SEMESTER V"],
              ["Sr. No.", "Course Code", "Course Name"],
              [1, "ME/22/T51", "Ship Stability"],
              [
                2,
                "ME/22/T52",
                "Marine Auxiliary Machine - II & Commercial Geography",
              ],
              [3, "ME/22/T53", "Marine Boiler & Steam Engineering"],
              [4, "ME/22/T54", "Marine Internal Combustion Engine – II"],
              [5, "ME/22/T55", "Basic Marine Control Engineering & Automation"],
              [6, "ME/22/T56", "Marine Machine & System Design"],
              [7, "ME/22/T57", "Marine Electrical Technology-I"],
              ["Practical Subjects"],
              ["Sr. No.", "Course Code", "Course Name"],
              [8, "ME/22/P58", "Marine Control Engineering Laboratory-l"],
              [9, "Tutorial"],
              [10, "VAC", "Welding Workshop (4G)"],
              [11, "ME/22/N59", "Officer Like Qualities"],
            ],
            [
              ["Third Year (B Tech) SEMESTER VI"],
              ["Sr. No.", "Course Code", "Course Name"],
              [1, "ME/22/T61", "Ship Fire Prevention"],
              [2, "ME/22/T62", "Marine Auxiliary Machine - III"],
              [3, "ME/22/T63", "STCW and Class IV Preparation - I"],
              [
                4,
                "ME/22/T64",
                "Advanced Marine Control Engineering & Automation",
              ],
              [5, "ME/22/T65", "Advance Marine Electrical Technology - II"],
              [6, "Tutorial (Presentation Skill & English Communication)"],
              ["Practical Subjects"],
              ["Sr. No.", "Course Code", "Course Name"],
              [7, "ME/22/P66", "Marine Control Engineering Laboratory-II"],
              [8, "ME/22/P67", "SIC Boiler Chemical Laboratory"],
              [9, "Tutorial"],
              [10, "VAC", "Welding Workshop (4G)"],
              [11, "ME/22/N68", "Officer Like Qualities"],
            ],
          ],
        },
        {
          title: "4th Year",
          tables: [
            [
              ["Fourth Year (B Tech) SEMESTER VII"],
              ["Sr. No.", "Course Code", "Course Name"],
              [1, "ME/22/T71", "Maintenance Repair of Machinery & DD"],
              [2, "ME/22/T72", "Introduction to Oil Tanker Operation"],
              [3, "ME/22/T73", "Engine Room Resource Management & Leadership"],
              ["Practical Subjects"],
              ["Sr. No.", "Course Code", "Course Name"],
              [5, "ME/22/S74", "Ship-in- Campus - I"],
              [6, "ME/22/S75", "Ship-in- Campus - II"],
              [, "ME/22/S76", "Ship-in- Campus - III"],
              [7, "ME/22/S77", "Ship-in- Campus - IV"],
              [8, "ME/22/S78", "Ship-in-Campus - (Fire Control Lab)"],
              [9, "ME/22/S79", "Ship-In-Campus PMS - Computer LAB"],
              [11, "ME/22/N/80", "Officer Like Qualities"],
            ],
            [
              ["Fourth Year (B Tech) SEMESTER VIII"],
              ["Sr. No.", "Course Code", "Course Name"],
              [1, "ME/22/S81", "Ship-in-Campus - V"],
              [2, "ME/22/S82", "Ship-in-Campus - VI"],
              [3, "ME/22/S83", "Ship-in-Campus – VII"],
              [4, "ME/22/S84", "Ship-in-Campus – VIII"],
              [5, "ME/22/S85", "Ship-in-Campus – IX"],
              [6, "ME/22/S86", "Ship-in-Campus - X"],
              [7, "ME/22/S87", "Power Plant Operation"],
              [8, "ME/22/S88", "Technical Paper & Seminar"],
              [9, "ME/22/N89", "Officer Like Qualities"],
            ],
          ],
        },
      ],
    },

    // 2nd accordion content
    {
      title: "B.Sc Nautical Science",
      sectionTitle:
        "Course Structure Outline For 3 YEAR B.SC Nautical Science ",
      semesters: [
        {
          title: "1st Year",
          tables: [
            [
              ["First Year (B. Sc.) SEMESTER I"],
              ["Sr.No.", "Course Code", "Course Name"],
              [1, "NS/T11", "English Communication"],
              [2, "NS/T12", "Applied Mathematics-I"],
              [3, "NS/T13", "Nautical Physics & Electronics - I"],
              [4, "NS/T14", "Marine Meteorology - I (Elective - 1)"],
              [5, "NS/T15", "Commercial Geography (Elective - 2)"],
              [6, "NS/P16", "Applied Mathematics Lab.-I"],
              [7, "NS/P17", "Nautical Physics & Electronics Lab. - I"],
              [8, "NS/P18", "Marine Meteorology Lab. - I"],
              [9, "NS/N19", "Officer Like Qualities"],
            ],
            [
              ["First Year (B. Sc.) SEMESTER II"],
              ["Sr. No.", "Course Code", "Course Name"],
              [1, "NS/T21", "Environmental Science"],
              [2, "NS/T22", "Applied Mathematics-II"],
              [3, "NS/T23", "Nautical Physics & Electronics - II"],
              [4, "NS/T24", "Marine Meteorology - II (Elective – 1)"],
              [5, "NS/T25", "STCW (Elective - 2)"],
              [6, "NS/P26", "Applied Mathematics Lab. - II"],
              [7, "NS/P27", "Nautical Physics & Electronics Lab. - II"],
              [8, "NS/P28", "Marine Meteorology Lab.- II"],
              [9, "NS/N29", "Officer Like Qualities"],
            ],
          ],
        },
        {
          title: "2nd Year",
          tables: [
            [
              ["Second Year (B.Sc.) SEMESTER III"],
              ["Sr. No.", "Course Code", "Course Name"],
              [1, "NS/T31", "Navigational Aids – I"],
              [2, "NS/T32", "Computer Science"],
              [3, "NS/T33", "Ship Operation Technology - I"],
              [
                4,
                "NS/T34",
                "Marine Engineering & Control Systems - I (Elective – 1)",
              ],
              [5, "NS/T35", "Oil Tanker Operations (Elective - 2)"],
              [6, "NS/P36", "Computer Science Lab."],
              [7, "NS/P37", "Ship Operation Technology Lab. - I"],
              [8, "NS/P38", "Marine Engineering & Control Systems Lab. - I"],
              [9, "NS/N39", "Officer Like Qualities"],
            ],
            [
              ["Second Year (B.Sc.) SEMESTER IV"],
              ["Sr.No.", "Course Code", "Course Name"],
              [1, "NS/T41", "Navigational Aids – II"],
              [2, "NS/T42", "English & Communication Skills"],
              [3, "NS/T43", "Ship Operation Technology - II"],
              [
                4,
                "NS/T44",
                "Marine Engineering & Control Systems – II (Elective – 1)",
              ],
              [5, "NS/T45", "Chemical Tanker Operations (Elective - 2)"],
              [6, "NS/P46", "English & Communication Skills Lab."],
              [7, "NS/P47", "Ship Operation Technology Lab. - II"],
              [8, "NS/P48", "Marine Engineering & Control Systems Lab.- II"],
              [9, "NS/N49", "Officer Like Qualities"],
            ],
          ],
        },
        {
          title: "3nd Year",
          tables: [
            [
              ["Third Year (B.Sc.) SEMESTER V"],
              ["Sr. No.", "Course Code", "Course Name"],
              [1, "NS/T51", "Naval Architecture - Ship Construction"],
              [2, "NS/T52", "Shipping Management & Maritime Law - I"],
              [3, "NS/T53", "Voyage Planning & Collision Prevention - I"],
              [4, "NS/T54", "Navigation - I (Elective – 1)"],
              [5, "NS/T55", "Gas Tanker Operations (Elective - 2)"],
              [6, "NS/P56", "Bridge Simulator Lab.-I"],
              [7, "NS/P57", "Workshop Training - I"],
              [8, "NS/P58", "Voyage Planning & Collision Prevention Lab. - I"],
              [9, "NS/N59", "Officer Like Qualities"],
            ],
            [
              ["Third Year (B.Sc.) SEMESTER VI"],
              ["Sr.No.", "Course Code", "Course Name"],
              [1, "NS/T61", "Naval Architecture - Ship Stability"],
              [2, "NS/T62", "Shipping Management & Maritime Law – II"],
              [3, "NS/T63", "Voyage Planning & Collision Prevention – II"],
              [4, "NS/T64", "Navigation - II (Elective – 1)"],
              [5, "NS/T65", "GMDSS (Elective - 2)"],
              [6, "NS/P66", "Bridge Simulator Lab.-II"],
              [7, "NS/P67", "Workshop Training – II"],
              [8, "NS/P68", "Voyage Planning & Collision Prevention Lab. - II"],
              [9, "NS/P69", "Navigation Lab. - II"],
              [10, "NS/N69", "Officer Like Qualities"],
            ],
          ],
        },
      ],
    },

    // 3rd accordion content
    {
      title: "Diploma In Nautical Science",
      sectionTitle:
        "Course Structure Outline For 1 YEAR Diploma In Nautical Science (DNS)",
      semesters: [
        {
          title: "1st Six Months",
          tables: [
            [
              ["1st Six Months"],
              ["Sr. No.", "Course Code", "Course Name"],
              [1, "24DNST11", "Applied Mathematics"],
              [2, "24DNST12", "Applied Sciences"],
              [3, "24DNST13", "Ship Construction & Ship Stability I"],
              [4, "24DNST14", "Navigation I: Navigation & Chartwork"],
              [
                5,
                "24DNST15",
                "Navigation II: Bridge Equipment Watchkeeping & Meteorology",
              ],
              [6, "24DNST16", "Cargo Handling Stowage and Seamanship I"],
              [7, "24DNST17", "English & Human Factors"],
              [8, "24DNSP11", "Applied Sciences Lab"],
              [9, "24DNSP12", "Computer Lab"],
              [10, "24DNSP13", "Workshop Practices"],
              [11, "24DNSP14", "Seamanship Lab"],
            ],
          ],
        },
        {
          title: "2nd Six Months",
          tables: [
            [
              ["2nd Six Months"],
              ["Sr. No.", "Course Code", "Course Name"],
              [1, "24DNST21", "Navigation III: Navigation & Chartwork"],
              [
                2,
                "24DNST22",
                "Navigation IV: Advanced Bridge Equip W/keeping and Meteorology",
              ],
              [3, "24DNST23", "Cargo Handling Stowage & Seamanship II"],
              [4, "24DNST24", "Ship Construction & Ship Stability - II"],
              [5, "24DNST25", "MARPOL & Marine Engineering Knowledge"],
              [
                6,
                "24DNST26",
                "Emergencies Maritime Communication and Commercial Shipping Knowledge",
              ],
              [7, "24DNSP21", "Communicative English Lab"],
              [8, "24DNSP22", "Workshop Practices & S'Ship"],
              [9, "24DNSP23", "Navigation Laboratory"],
            ],
          ],
        },
      ],
    },

    // 4th accordion content
    {
      title: " Electro Techincal Officer (ETO)",
      sectionTitle:
        "Course Structure Outline For 4 Months  Electro Techincal Officer (ETO)",
      semesters: [
        {
          title: "ETO ",
          tables: [
            [
              ["ETO"],
              ["Sr. No.", "Course Code", "Course Name"],
              [1, "24ETO-T1", "Marine Engineering Knowledge"],
              [2, "24ETO-T2", "Marine Electro- Technology"],
              [3, "24ETO-T3", "Marine Control and automation"],
              [
                4,
                "24ETO-T4",
                "Marine Communications Management and Conventions",
              ],
              [5, "24ETO-T5", "Communicative English and Computer Networks"],
              [6, "24ETO-P1", "Marine Engineering Workshop & Seamanship Lab"],
              [7, "24ETO-P2", "Marine Electro technology Practical"],
              [8, "24ETO-P3", "Marine Control and Automation Laboratory"],
              [9, "24ETO-P4", "Computer Network Laboratory"],
            ],
          ],
        },
      ],
    },
  ];

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
    setActiveSem(null); // reset semester when course changes
  };

  const toggleSemester = (index) => {
    setActiveSem(activeSem === index ? null : index);
  };

  return (
    <div>
      <h1 className="title"> Syllabus</h1>
      <hr />

      <div className=".page-content-container ">
        {syllabusData.map((course, courseIndex) => (
          <div key={courseIndex} className="accordion-item">
            {/* Accordion Header */}
            <Accordion
              title={course.title}
              isActive={activeAccordion === courseIndex}
              onClick={() => toggleAccordion(courseIndex)}
            />

            {/* Accordion Content */}
            {activeAccordion === courseIndex && (
              <div className="accordion-content">
                {/* Section title*/}
                {course.sectionTitle && (
                  <h4 className="innerpage-heading" id="syllabus-title">{course.sectionTitle}</h4>
                )}
                <div className="page-content-btns">
                  {course.semesters.map((sem, semIndex) => (
                    <button
                      key={semIndex}
                      className={`page-content-btn ${
                        activeSem === semIndex ? "active" : ""
                      }`}
                      onClick={() => toggleSemester(semIndex)}
                    >
                      {sem.title}
                    </button>
                  ))}
                </div>

                {/* Tables Section */}
                {activeSem !== null && (
                  <div className="semester-content">
                    {/* Tables */}
                    <div className="syllabus-tables-grid">
                      {course.semesters[activeSem].tables.map(
                        (table, tableIndex) => (
                          <div className="table-responsive">
                            <div key={tableIndex}>
                              <table
                                className="page-content-table"
                                id="syllabus-table"
                              >
                                <tbody>
                                  {table.map((row, rowIndex) => {
                                    // If the row has only one cell, treat it as a section title
                                    if (row.length === 1) {
                                      // Find the max number of columns from nearby header rows
                                      const nextHeader = table.find(
                                        (r) => r.length > 1
                                      );
                                      const colCount = nextHeader
                                        ? nextHeader.length
                                        : 1;

                                      return (
                                        <tr key={rowIndex}>
                                          <th
                                            colSpan={colCount}
                                            style={{ textAlign: "center" }}
                                          >
                                            {row[0]}
                                          </th>
                                        </tr>
                                      );
                                    }

                                    // If it's a normal header row (contains "Sr No" etc.)
                                    if (
                                      row.includes("Sr No") ||
                                      row.includes("Course Code") ||
                                      row.includes("Course Name")
                                    ) {
                                      return (
                                        <tr
                                          key={rowIndex}
                                          className="table-subheading"
                                        >
                                          {row.map((cell, cellIndex) => (
                                            <th key={cellIndex}>{cell}</th>
                                          ))}
                                        </tr>
                                      );
                                    }

                                    // Otherwise, it's a normal data row
                                    return (
                                      <tr key={rowIndex}>
                                        {row.map((cell, cellIndex) => (
                                          <td key={cellIndex}>{cell}</td>
                                        ))}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Syllabus;
